import debounce from 'lodash/debounce'
import * as moment from 'moment/moment'

export const bugReportDetail = {
    data() {
        return {
          totalCount: 0,
          currentPage: 1,
          perPage: 100,
          manage_by: null,
          reporting_to: null,
          reporting_to_users: [],
          manage_by_users: [],
          loader: false,
          search: null,
          startDate: `${moment().format("YYYY")}-${moment().quarter()}`,
          fields: [
            {
              key: "full_name",
              label: "Name",
            },
            {
              key: "reporting_to",
              label: "Reporting To",
              thStyle: { align: "start !important" },
              thStyle: { align: "start !important" },
            },
            {
              key: "manage_by",
              label: "Manage By",
              thStyle: { align: "start !important" },
              thStyle: { align: "start !important" },
            },
            {
              key: "bug_count",
              label: "Bug Count",
              thClass: "text-center",
              tdClass: "text-center",
            },
            {
              key: "improvement_count",
              label: "Improvement Count",
              thClass: "text-center",
              tdClass: "text-center",
            },
          ],
          items: [],
        };
    },
    computed: {
        debouncedSearch: {
            get() {
                return this.search
            },
            set: debounce(function (value) {
                this.search = value
                this.bugReport()
            }, 750),
        },
    },    watch: {
        currentPage: {
            handler(value) {
                if (value) {
                    this.bugReport()
                }
            },
        },
        perPage() {
            if (this.currentPage == 1) {
                this.bugReport()
            } else {
                this.currentPage = 1
            }
        },
        startDate(nv) {
            if (nv) {
                setTimeout(() => {
                    this.bugReport()
                }, 200)
            }
        },
    },
    mounted() {
        if (this.userInfo.role != 'SA') {
            this.manage_by = this.userInfo.id
        }

        const queryParams = this.$route.query
        if (queryParams && Object.keys(queryParams).length > 0) {
            if (queryParams.manage_by) this.manage_by = queryParams.manage_by
            if (queryParams.reporting_to) this.reporting_to = queryParams.reporting_to
            if (queryParams.search) this.search = queryParams.search
            if (queryParams.startDate) this.startDate = queryParams.startDate
            if (queryParams.perPage) this.perPage = Number(queryParams.perPage)
            if (queryParams.currentPage) this.currentPage = Number(queryParams.currentPage)
        }

        this.filterFunctionCallFromMixin()
        this.bugReport()
    },
    methods: {
        updateQueryParams() {
            const query = this.getQueryParams();
            this.routeQueryUpdate(query);
        },

        getQueryParams() {
            const queryParams = {
                manage_by: this.manage_by,
                reporting_to: this.reporting_to,
                search: this.search,
                startDate: this.startDate,
                perPage: this.perPage,
                currentPage: this.currentPage,
            }

            return Object.keys(queryParams).reduce((acc, key) => {
                if (queryParams[key]) acc[key] = queryParams[key]
                return acc;
            }, {});
        },

        async filterFunctionCallFromMixin() {
            this.manage_by_users = await this.manageByUserList()
            this.reporting_to_users = await this.reportingtoUserList()
        },

        async bugReport() {
            this.loader = true
            this.updateQueryParams()
            const input = {
                page: this.currentPage,
                per_page: this.perPage,
                sort_field: 'name',
                sort_order: 'asc',
                search: this.search,
                start_date: moment(this.startDate, 'YYYY-Q').startOf('quarter').format('YYYY-MM-DD'),
                end_date: moment(this.startDate, 'YYYY-Q').endOf('quarter').format('YYYY-MM-DD'),
                manage_by: this.manage_by ? this.manage_by : null,
                reporting_to: this.reporting_to ? this.reporting_to : null,
            }
            const response = await this.getHTTPPostResponse('admin/master/reports/bug-report', input, false)
            if (response && response.data) {
                const { data } = response
                this.items = data.bug_report
                this.totalCount = data.count
            }
            this.loader = false
        },
        resetFilterState() {
            this.manage_by = null
            this.reporting_to = null
            this.perPage = 100
            this.search = null
            this.startDate = `${moment().format("YYYY")}-${moment().quarter()}`
        },
        clearFilter() {
            this.resetFilterState()
            this.bugReport()
        },
    },
}